import React from "react";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import VacancyCard from "../../components/VacancyCard.jsx";
import Loader from "../../components/Loader.jsx";
import ErrorPage from "../ErrorPage.jsx";
import "../../styles/pages/subpages/vacancies_page.css";

import ChevronRightIcon from "../../assets/icons/chevron-right.svg";
import VacanciesPageImage from "../../assets/images/vacancies_page_image.png";

import { useQuery } from "@tanstack/react-query";
import { fetchVacancies } from "../../services/apiService.js";

const VacanciesPage = () => {
  const { data: vacanciesData, isLoading, error } = useQuery({
    queryKey: ["vacancies"],
    queryFn: fetchVacancies,
  });

  if (error) {
    return <ErrorPage />;
  }

  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="vacancies-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">Главная</a>
        <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
        <a href="/about_company" className="nav-link">О компании</a>
        <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
        <span className="nav-link">Вакансии компании</span>
      </nav>

      <div className="vacancies-page-content">
        <div className="vacancies-info-section">
          <div className="vacancies-info-text-block">
            <h2 className="gradient-page-title desktop-only">Вакансии компании</h2>
            <h2 className="small-section-title">Уважаемые кандидаты на трудоустройство!</h2>
            <p className="vacancies-info-paragraph">
              ОсОО "ШНОС" (Сеть АЗС "Bishkek Petroleum") — динамично развивающаяся компания с энергичной, инициативной и целеустремленной командой профессионалов.
            </p>
            <p className="vacancies-info-paragraph">
              Мы заинтересованы в поиске людей, готовых работать и развивать свои профессиональные знания и опыт вместе с нашей командой.
            </p>
            <p className="vacancies-info-paragraph">
              В этом разделе вы можете получить всю необходимую информацию о вакансиях компании и контакты соответствующих специалистов.
            </p>
            <p className="vacancies-info-paragraph">
              Нам нужны профессионалы, которые разбираются в своём деле, и мы ценим кандидатов, способных совмещать профессионализм с личными качествами.
            </p>
          </div>
          <div className="vacancies-image-block">
            <img src={VacanciesPageImage} alt="Stations" className="vacancies-image" />
            <h2 className="gradient-page-title mobile-only">Вакансии компании</h2>
          </div>
        </div>

        <div className="vacancies-container">
          {vacanciesData && vacanciesData.length > 0 ? (
            vacanciesData.map((vacancy) => (
              <VacancyCard
                key={vacancy.id}
                title={vacancy.title}
                responsibilities={vacancy.description}
                requirements={vacancy.points}
              />
            ))
          ) : (
            <p className="loading-text">Нет вакансий</p>
          )}
        </div>

        <div className="vacancies-contact-block">
          <div className="vacancies-contacts">
            <span className="vacancies-contacts-title">
              Отдел управления <br /> персоналом ОсОО "ШНОС"
            </span>
            <span className="vacancies-contact">
              тел: <span className="number">+996 (312) 303 303</span>
            </span>
            <span className="vacancies-contact">
              <span className="number">+996 (312) 303 303</span>, вн. номер 131, 132
            </span>
            <span className="vacancies-contact">
              факс: <span className="number">+996 312 303 303</span>
            </span>
          </div>
          <p className="vacancies-contact-text">
            Если вы хотите стать частью нашей команды, отправьте резюме на адрес:
            <br /> эл. адрес: <u className="email">hr@bpetroleum.kg</u>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default VacanciesPage;
